import { useState, useEffect } from 'react'

import { DocumentsFilter } from '../interfaces/CardOne'

export interface DealsFilters {
  clickedIndex: number
  filterData: DocumentsFilter
  searchTerm: string
  statusFilter: 'all' | 'late' | 'ontime'
}

const defaultFilters: DealsFilters = {
  clickedIndex: 0,
  filterData: {
    salesPerson: '',
    dateSince: '',
    dateUntil: '',
  },
  searchTerm: '',
  statusFilter: 'all',
}

const STORAGE_KEY = 'deals_filters'

export const useDealsFilters = () => {
  const [filters, setFilters] = useState<DealsFilters>(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)

      return stored ? JSON.parse(stored) : defaultFilters
    } catch {
      return defaultFilters
    }
  })

  // Save to sessionStorage whenever filters change
  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters))
  }, [filters])

  const updateFilters = (newFilters: Partial<DealsFilters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }))
  }

  const resetFilters = () => {
    setFilters(defaultFilters)
    sessionStorage.removeItem(STORAGE_KEY)
  }

  const clearFilters = () => {
    sessionStorage.removeItem(STORAGE_KEY)
  }

  return {
    filters,
    updateFilters,
    resetFilters,
    clearFilters,
  }
}
